


















































































































































































































































































import { COLLECTION_POSTS, COLLECTION_USERS } from '@/model/AppConstants';
import FirebaseUtil from '@/model/FirebaseUtil';
import StatusType from '@/model/typelist/StatusType';
import { Vue, Component } from 'vue-property-decorator';
import Post from '@/model/Post';
import {
  Facebook,
  Twitter,
  Linkedin,
  Telegram,
  WhatsApp,
} from 'vue-socialmedia-share';

@Component({
  components: {
    Facebook,
    Twitter,
    Linkedin,
    Telegram,
    WhatsApp,
  },
})
export default class Report extends Vue {
  tabs = null;

  items = ['Reported Posts', 'Rejected Posts'];

  mounted() {
    this.$store.dispatch('bindReportPagePosts', StatusType.reported);
    this.$store.dispatch('bindRejectedPosts', StatusType.rejected);
  }
  // eslint-disable-next-line
  postBg(post: any) {
    return `backgroundColor:${post.postTile.bgColor}`;
  }
  // eslint-disable-next-line
  postFont(post: any) {
    return `fontFamily:${post.postTile.fontFamily}`;
  }

  get reportedPost() {
    return this.$store.state.reportPagePosts;
  }

  get rejectPost() {
    return this.$store.state.rejectPosts;
  }
  // eslint-disable-next-line
  updateStatus(postObj: any, status: StatusType) {
    Post.updateStatus(postObj, status);
  }

  approveStatus(post: any) {
    this.updateStatus(post, StatusType.approved);
  }

  rejectStatus(post: any) {
    this.updateStatus(post, StatusType.rejected);
  }
}
